module.exports = __webpack_public_path__ + "ff49af3b3ab37c9f06e64a1d2e592520.svg";